export const headers = [
  {
    key: '',
    i18n: 'ACCESS_KEY',
    centerTitle: true,
    style: { width: 30, fontSize: 12 },
  },
  {
    order: true,
    key: 'client_name',
    i18n: 'OPERATOR_VIEW_NAME_KEY',
    style: { width: 80, fontSize: 12 },
  },
  {
    order: true,
    key: 'environment_name',
    i18n: 'OPERATOR_VIEW_ENVIRONMENT_NAME_KEY',
    style: { width: 110, fontSize: 12 },
  },
  {
    order: true,
    key: 'partner_name',
    i18n: 'OPERATOR_VIEW_PARTNER_NAME_KEY',
    style: {
      width: 80,
      fontSize: 12,
    },
  },
  {
    order: true,
    key: 'num_users',
    i18n: 'USERS_KEY',
    style: { width: 30, fontSize: 12 },
    centerTitle: true,
  },
  {
    order: true,
    key: 'user_last_access',
    i18n: 'LAST_ACCESS_SINGULAR_KEY',
    centerTitle: true,
    style: { width: 10, fontSize: 12 },
  },
  {
    key: '',
    i18n: 'ACTIONS_KEY',
    centerTitle: true,
    style: { width: 30, fontSize: 12 },
  },
];
